import { defineStore } from 'pinia';
import { ref } from 'vue';

import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';

const PRODUCT_URL = process.env.VUE_APP_API_VERSION + '/products';

export const useProductStore = defineStore('product', () => {
    const products = ref([]);

    const getAllProducts = async () => {
        try {
            const response = await authApi.get(PRODUCT_URL);
            if (response.statusCode === 200) {
                products.value = response.data;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to fetch all products');
        }
    };

    return {
        products,
        getAllProducts,
    };
});
